import { useForm } from "react-hook-form";
import useNav from "../../../../hooks/useNav";
import { Button, FormControl, FormLabel, Modal, TextareaAutosize, TextField } from "@mui/material";
import ContainerModal from "../../../../components/modalExportar/components/containerModal";
import { SelectCargoGrupo } from "../../../../components/selects/cargoGrupo";
import { SelectCargo } from "../../../../components/selects/cargo";


export const CargoAdd = () => {
  const { goBack, navTo } = useNav();

  const {
    register,
    watch,
    setValue
  } = useForm<{ descricao: string, codigo: string, grupo: number, cargopai: number, observacoes: string }>({
    defaultValues: {
      descricao: null,
      cargopai: null,
      observacoes: null,
      codigo: null,
      grupo: null
    }
  });


  return (
    <>
      <Modal open={true} onClose={goBack}>
        <ContainerModal props={{ display: 'grid', rowGap: 1 }}>
          <FormControl fullWidth>
            <TextField
              {...register('descricao')}
              label="Descrição"
              sx={{ width: '100%' }}
            />
          </FormControl>
          <FormControl fullWidth sx={{ margintTop: 2 }}>
            <TextField
              {...register('codigo')}
              label="Código"
              sx={{ width: '100%' }}
            />
          </FormControl>
          <SelectCargoGrupo action={(grupo) => { setValue('grupo', grupo?.target?.value) }} valor={watch('grupo')} />
          <SelectCargo titulo="Cargo Pai" action={(cargo) => { setValue('cargopai', cargo?.target?.value) }} valor={watch('cargopai')} />
          <FormControl fullWidth>
            <FormLabel >Observações</FormLabel>
            <TextareaAutosize
              {...register('observacoes')}
              style={{
                width: '100%',
                minHeight: 60,
                borderRadius: 4,
                borderColor: '#ccc',
                resize: 'none',
                padding: '4px 8px'
              }}
            />
          </FormControl>
          <div style={{
            display: "flex", marginTop: 8, justifyContent: 'space-between', alignItems: 'center', width: '100%'
          }}>
            <Button variant="contained">Confirmar</Button>
            <Button variant="contained" color="error" onClick={goBack}>Cancelar</Button>
          </div>
        </ContainerModal>
      </Modal>
    </>
  )
}
